export const dealTypes = {
    TYPE_BUY: 101,
    TYPE_SELL: 102,
    TYPE_DEPOSITING: 201,
    TYPE_WITHDRAWAL: 202,
    TYPE_INCOME_DIVIDEND: 301,
    TYPE_INCOME_COUPON: 302,
    TYPE_INCOME_AMORTIZATION: 303,
    TYPE_EXPENSE_COMMISSION: 401,
    TYPE_EXPENSE_TAX: 402,
};